
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    openButton: 'Open',
    freeOpenButton: 'Open for free',
    itemsInCase: 'Items in case',
    balance: 'Balance',
    notFoundTitle: 'Case not found',
    notFoundText: 'This case is no longer available — it may have been taken down or the link is broken.',
    backToCases: 'Back to cases',
  },
  ru: {
    openButton: 'Открыть',
    freeOpenButton: 'Открыть бесплатно',
    itemsInCase: 'Предметы в кейсе',
    balance: 'Баланс',
    notFoundTitle: 'Кейс не найден',
    notFoundText: 'Этого кейса больше нет — его убрали или ссылка битая.',
    backToCases: 'Вернуться к кейсам',
  },
  uz: {
    openButton: 'Ochish',
    freeOpenButton: 'Bepul ochish',
    itemsInCase: 'Keysdagi buyumlar',
    balance: 'Balans',
    notFoundTitle: 'Keys topilmadi',
    notFoundText: 'Bu keys endi yoʻq — uni olib tashlagan boʻlishi mumkin yoki havola buzilgan.',
    backToCases: 'Keyslarga qaytish',
  },
  fa: {
    openButton: 'باز کن',
    freeOpenButton: 'رایگان باز کن',
    itemsInCase: 'آیتم‌های داخل کیس',
    balance: 'موجودی',
    notFoundTitle: 'کیس پیدا نشد',
    notFoundText: 'این کیس دیگر در دسترس نیست — یا برداشته شده یا لینک خراب است.',
    backToCases: 'برگشت به کیس‌ها',
  },
  pt: {
    openButton: 'Abrir',
    freeOpenButton: 'Abrir de graça',
    itemsInCase: 'Itens na caixa',
    balance: 'Saldo',
    notFoundTitle: 'Caixa não encontrada',
    notFoundText: 'Essa caixa não existe mais — ela foi removida ou o link está quebrado.',
    backToCases: 'Voltar para as caixas',
  },
  tr: {
    openButton: 'Aç',
    freeOpenButton: 'Ücretsiz aç',
    itemsInCase: 'Kasadaki eşyalar',
    balance: 'Bakiye',
    notFoundTitle: 'Kasa bulunamadı',
    notFoundText: 'Bu kasa artık yok — kaldırılmış ya da link bozuk.',
    backToCases: 'Kasalara dön',
  },
});
